import { Record, Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, class_type, union_type, option_type, string_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Account_LoginResult_$reflection, Account_UserStatus_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMsg_$reflection } from "../../../Bfs.Web.Portale/Types.fs.js";
import { FormField__get_IsValid, ValidationRule, FormField_Init_Z1F39563A, FormField_$reflection } from "../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Login"];
    }
}

export function Page_$reflection() {
    return union_type("Login.Types.Page", [], Page, () => [[["Item", option_type(string_type)]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CheckBrowser", "CheckLogin", "LoginChecked", "NameChanged", "PasswordChanged", "OtpChanged", "NutzungsbedingungenAkzeptiert", "PrintNutzungsbedingungen", "Submit", "Submitted", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Login.Types.Msg", [], Msg, () => [[], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Account_UserStatus_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Account_UserStatus_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [["Item", string_type]], [["Item", option_type(bool_type)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Account_LoginResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Account_LoginResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(Name, Password, Otp, OtpRequired, Loading, Sending, ErrorMsg, WartungMsg, GotoAfterLogin) {
        super();
        this.Name = Name;
        this.Password = Password;
        this.Otp = Otp;
        this.OtpRequired = OtpRequired;
        this.Loading = Loading;
        this.Sending = Sending;
        this.ErrorMsg = ErrorMsg;
        this.WartungMsg = WartungMsg;
        this.GotoAfterLogin = GotoAfterLogin;
    }
}

export function Model_$reflection() {
    return record_type("Login.Types.Model", [], Model, () => [["Name", FormField_$reflection()], ["Password", FormField_$reflection()], ["Otp", FormField_$reflection()], ["OtpRequired", bool_type], ["Loading", bool_type], ["Sending", bool_type], ["ErrorMsg", option_type(string_type)], ["WartungMsg", option_type(string_type)], ["GotoAfterLogin", option_type(string_type)]]);
}

export function Model_Init_6DFDD678(goto) {
    return new Model(FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), false, true, false, undefined, undefined, goto);
}

export function Model__get_CanSubmit(x) {
    if ((((!x.Loading && !x.Sending) && FormField__get_IsValid(x.Name)) && FormField__get_IsValid(x.Password)) && (!x.OtpRequired ? true : FormField__get_IsValid(x.Otp))) {
        return x.WartungMsg == null;
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Types.fs.js.map
